import React from 'react';

function NotFoundPage() {
    return <div>no such route</div>;
}

export default NotFoundPage;